module.exports = __webpack_public_path__ + "static/media/az-0.77ac38d9.jpg";